
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';
const ComponentsBreadcrumb = (props) => {
  const extraBreadcrumbItems = props.breadCrumbList?.map((name, index) => {
    return (
      <Breadcrumb.Item key={name.url}>
        {name.url && <Link to={name.url} className={index === props.breadCrumbList?.length - 1 ? 'breadcrumb-active-item breadcrumb-link' : 'breadcrumb-link'}>{name.bname}</Link>}
        {!name.url && <p className={index !== props.breadCrumbList?.length - 1 ? 'text-white' : 'breadcrumb-active-item'}>{name.bname}</p>}
      </Breadcrumb.Item>

    );
  });
  const breadcrumbItems = [
    <Breadcrumb.Item key="/dashboard"></Breadcrumb.Item>,
  ].concat(extraBreadcrumbItems);

  return (
    <Breadcrumb className='mb-24' separator={<span className='icon bc-arrow' />}>{breadcrumbItems}</Breadcrumb>)
}
export default ComponentsBreadcrumb;